import { useEffect } from 'react';
import { site } from '../data/site';
const TITLE = `${site.name} — Web design studio, India`;
const DESCRIPTION = 'A small independent studio designing and building websites for founder-led companies. Fixed pricing from ₹ 15,000.';
function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(selector);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

/**
 * Owns the document title and social metadata. Rendered once from Layout, so
 * the studio name only ever comes from data/site.ts.
 */
export function SiteMeta() {
  useEffect(() => {
    document.title = TITLE;
    setMeta('meta[name="description"]', 'name', 'description', DESCRIPTION);
    setMeta('meta[property="og:title"]', 'property', 'og:title', TITLE);
    setMeta('meta[property="og:description"]', 'property', 'og:description', DESCRIPTION);
    setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', site.name);
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
  }, []);
  return null;
}